import React, {Component} from "react";

import PropTypes from "prop-types";

class FixedBlock extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fixedElement: null,
            fixed: false,
            bottom: false
        }
        this.els = {}
    }

    componentDidMount() {
        this.setState({
            fixedElement: document.querySelector(this.props.elementfixed)
        })

        this.els.titleAuthor = document.querySelector('.title-author');
        var h = this.els.titleAuthor.offsetHeight;
        h += parseInt(window.getComputedStyle(this.els.titleAuthor).getPropertyValue('margin-top'));
        h += parseInt(window.getComputedStyle(this.els.titleAuthor).getPropertyValue('margin-bottom'));
        let windowWidth = window.innerWidth
        if (windowWidth <= 1023) h = 0
        this.setState({h})

        window.addEventListener('scroll', this.updateFix.bind(this));
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        if (this.state.fixed) {
            this.setState({
                fixed: false
            })
            this.removeFixedElement()
        }

        this.updateFix()
    }

    updateFix() {
        let windowWidth = window.innerWidth

        if (windowWidth < 1024) return

        if (this.props.maxsize == undefined && this.props.minsize == undefined) {
            this.heightControl();
        }

        else if ((this.props.maxsize != undefined && this.props.minsize == undefined) && (windowWidth <= this.props.maxsize)) {
            this.heightControl()
        }

        else if ((this.props.maxsize == undefined && this.props.minsize != undefined) && (windowWidth >= this.props.minsize)) {
            this.heightControl()
        }

        else if ((this.props.maxsize != undefined && this.props.minsize != undefined) && (windowWidth <= this.props.maxsize && windowWidth >= this.props.minsize)) {
            this.heightControl();
        }

        else {
            if (this.state.fixed) {
                this.removeFixedElement();
                this.setState({
                    fixed: false,
                    bottom: false
                })
            }
        }
    }

    heightControl() {
        let actualScroll = window.window.pageYOffset
        let elementTop = this.props.proxy.offsetTop
        let maxScroll = elementTop + this.props.proxy.offsetHeight

        if (actualScroll >= (elementTop - 80 - this.state.h) && actualScroll <= maxScroll) {
            if (!this.state.fixed) {
                this.setState({
                    fixed: true
                })

                this.setFixedElement()
            }
            else {
                if (actualScroll >= (maxScroll - this.state.fixedElement.offsetHeight - 80)) {
                    if (!this.state.bottom) {
                        this.state.fixedElement.classList.add("bottom");
                        this.removeFixedElement()
                        this.setState({fixed: false})
                    }

                    this.setState({bottom: true})
                }
                else {
                    if (this.state.bottom) {
                        this.setState({bottom: false})
                        this.state.fixedElement.className = this.state.fixedElement.className.replace("bottom", "");
                        this.setFixedElement()
                    }
                }
            }
        }
        else {
            if (this.state.fixed) {
                this.setState({
                    fixed: false
                })

                this.removeFixedElement()
            }
        }

    }

    removeFixedElement() {
        document.querySelector(this.props.elementfixed + ".fixed").style.left = "";
        document.querySelector(this.props.elementfixed + ".fixed").style.marginTop = `-${this.state.h}px`;
        this.state.fixedElement.className = this.state.fixedElement.className.replace("fixed", "");
    }

    setFixedElement() {
        let elementLeft = this.state.fixedElement.getBoundingClientRect().left;
        this.state.fixedElement.classList.add("fixed");
        document.querySelector(this.props.elementfixed + ".fixed").style.left = elementLeft + "px";
        document.querySelector(this.props.elementfixed + ".fixed").style.marginTop = 0;
    }

    render() {
        return <div></div>
    }
}

FixedBlock.propTypes = {
    elementfixed: PropTypes.string,
    maxsize: PropTypes.string,
    minsize: PropTypes.string,
}

export default (FixedBlock)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/FixedBlock.js